var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBell = function SvgBell(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.90909,
    y: 1.90909,
    width: 26.1818,
    height: 26.1818,
    rx: 13.0909,
    fill: "#EA5353"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.90909,
    y: 1.90909,
    width: 26.1818,
    height: 26.1818,
    rx: 13.0909,
    stroke: "white",
    strokeWidth: 2.18182
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3638 19.3633C13.3638 20.2671 14.0963 20.9996 15.0001 20.9996C15.904 20.9996 16.6365 20.2671 16.6365 19.3633H13.3638Z",
    fill: "#F3CED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8181 14.273V13.5241C18.8181 11.4333 17.2074 9.61042 15.1172 9.54769C12.955 9.48224 11.1818 11.2157 11.1818 13.3637V14.273C11.1818 15.0993 10.914 15.9028 10.4181 16.5639L9.79086 17.4001C9.63159 17.6122 9.54541 17.8708 9.54541 18.1364C9.54541 18.8144 10.0947 19.3637 10.7727 19.3637H19.2272C19.9052 19.3637 20.4545 18.8144 20.4545 18.1364C20.4545 17.8708 20.3683 17.6122 20.209 17.4001L19.5818 16.5639C19.086 15.9028 18.8181 15.0988 18.8181 14.273Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBell);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bell.b1ebd8b3ebb05bd62f815c60fbe36754.svg";